import React from "react";
import { Camera, Image as ImageIcon } from "lucide-react";

export default function StudentEditPhotoUploadSection({
  formData,
  isUploading,
  onImageUpload,
}) {
  return (
    <div className="flex justify-center mb-6">
      <div className="relative group cursor-pointer">
        {formData.photoUrl ? (
          <img
            src={formData.photoUrl}
            alt="profile"
            className="w-32 h-32 rounded-[2rem] object-cover border-4 border-white shadow-lg"
          />
        ) : (
          <div className="w-32 h-32 rounded-[2rem] bg-gray-50 border-4 border-white shadow-inner flex items-center justify-center overflow-hidden relative">
            <img
              src={formData.gender === "남" ? "/images/boy_animated_light.png" : "/images/girl_animated_light.png"}
              alt="Default Profile"
              className="w-full h-full object-cover opacity-80"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/10">
              <Camera size={32} className="text-white drop-shadow-md" />
            </div>
          </div>
        )}
        <label className="absolute inset-0 bg-black/30 rounded-[2rem] flex items-center justify-center opacity-0 group-hover:opacity-100 transition cursor-pointer text-white font-bold text-sm">
          <ImageIcon size={20} className="mr-1" /> 변경
          <input
            id="student-edit-photo-upload"
            name="student_edit_photo_upload"
            type="file"
            className="hidden"
            accept="image/*"
            onChange={onImageUpload}
          />
        </label>
        {isUploading && (
          <div className="absolute inset-0 bg-black/50 rounded-[2rem] flex items-center justify-center text-white text-xs font-bold">
            업로드 중...
          </div>
        )}
      </div>
    </div>
  );
}
